/* سمسم ورلد – سكريبتات عامة (أزرار الكروت، الأسعار، التقييم، العد التنازلي) */
(() => {
    const cardSelector = '.product-item';

    function prepareControl(control) {
      if (!control) return;

      control.classList.add('pr-card-purchase-control');

      let labels;

      if (control.matches('product-form')) {
        labels = control.querySelectorAll('.btn-action');
      } else {
        labels = control.querySelectorAll(
          'span.hidden-on-load, span.block-1025'
        );
      }

      labels.forEach((label) => {
        label.classList.remove('hidden', 'block-1025');
      });
    }

    function findPurchaseControl(card) {
      const information = card.querySelector(
        '.product-item__information'
      );

      const existingControl = information?.querySelector(
        ':scope > .pr-card-purchase-control'
      );

      if (existingControl) {
        return existingControl;
      }

      const direct = card.querySelector(
        [
          '.product-item__action product-form.product-item__product-form',
          '.product-item__action select-option.product-item__select-options',
          '.product-item__action a.product-item__select-options',
          '.product-item__action button.product-item__select-options',
          '.product-item__action select-option.product__add-cart'
        ].join(',')
      );

      if (direct) return direct;

      const actionArea = card.querySelector('.product-item__action');

      if (!actionArea) return null;

      const optionTextPattern =
        /حدد\s*الخيارات|تحديد\s*الخيارات|اختر\s*الخيارات|select\s*options|choose\s*options/i;

      const clickableElements = actionArea.querySelectorAll(
        'a[href], button, [role="button"]'
      );

      for (const element of clickableElements) {
        if (optionTextPattern.test(element.textContent || '')) {
          return element;
        }
      }

      return null;
    }

    function positionPurchaseControl(card) {
      if (!(card instanceof Element)) return;

      const information = card.querySelector(
        '.product-item__information'
      );

      if (!information) return;

      const control = findPurchaseControl(card);

      if (!control) return;

      prepareControl(control);

      if (control.parentElement !== information) {
        information.appendChild(control);
      }
    }

    function processNode(node) {
      if (!(node instanceof Element)) return;

      if (node.matches(cardSelector)) {
        positionPurchaseControl(node);
      }

      const parentCard = node.closest(cardSelector);

      if (parentCard) {
        positionPurchaseControl(parentCard);
      }

      node.querySelectorAll(cardSelector).forEach(
        positionPurchaseControl
      );
    }

    document.querySelectorAll(cardSelector).forEach(
      positionPurchaseControl
    );

    const pendingNodes = new Set();
    let scheduled = false;

    function flushPendingNodes() {
      pendingNodes.forEach(processNode);
      pendingNodes.clear();
      scheduled = false;
    }

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            pendingNodes.add(node);
          }
        });
      });

      if (!scheduled && pendingNodes.size) {
        scheduled = true;
        requestAnimationFrame(flushPendingNodes);
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    document.addEventListener('shopify:section:load', (event) => {
      processNode(event.target);
    });
  })();
;
document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('recipient-form').forEach(function (recipientForm) {
      const checkbox = recipientForm.querySelector(
        'input[type="checkbox"][name="properties[__shopify_send_gift_card_to_recipient]"]'
      );

      if (checkbox && !checkbox.checked) {
        checkbox.checked = true;
        checkbox.dispatchEvent(
          new Event('change', {
            bubbles: true
          })
        );
      }
    });
  });
;
(function(){function f(t){return parseFloat((t||'').replace(/[^0-9.]/g,''))||0}function u(b){var n=b.querySelector('.smsm-price__now'),w=b.querySelector('.smsm-price__was'),d=b.querySelector('.smsm-price__deal');if(!n||!w||!d)return;var a=f(n.textContent),c=f(w.textContent),s=Math.round(c-a);if(!(s>0)||!w.textContent.trim()||(Math.round(s*100/c)<10&&s<500)){if(d.style.display!=='none')d.style.display='none';return}if(d.style.display)d.style.display='';var o=d.querySelector('.smsm-price__off'),v=d.querySelector('.smsm-price__save');var ot='-'+Math.round(s*100/c)+'%';if(o.textContent!==ot)o.textContent=ot;var tp=n.textContent.trim(),m=tp.match(/[0-9][0-9,.]*/),lb=v.textContent.trim().split(' ')[0];var vt=lb+' '+(m?tp.replace(m[0],s.toLocaleString('en-US')):s);if(v.textContent!==vt)v.textContent=vt}var q=0;function run(){q=0;document.querySelectorAll('.smsm-price').forEach(u)}document.querySelectorAll('.product-detail__price').forEach(function(el){new MutationObserver(function(){if(!q)q=requestAnimationFrame(run)}).observe(el,{subtree:true,childList:true,characterData:true})})})();
;
(function(){function go(){document.querySelectorAll('.product-item').forEach(function(it){var inner=it.querySelector('.product-item__inner');if(!inner||inner.querySelector('.smsm-rate'))return;var b=it.querySelector('.jdgm-prev-badge');if(!b)return;var n=parseInt(b.getAttribute('data-number-of-reviews')||'0',10),r=parseFloat(b.getAttribute('data-average-rating')||'0');if(!(n>0&&r>0))return;var s=document.createElement('span');s.className='smsm-rate';s.innerHTML='<b>★</b>'+r.toFixed(1);s.setAttribute('aria-label',r.toFixed(1)+' / 5');s.style[getComputedStyle(inner).direction==='rtl'?'left':'right']='10px';inner.appendChild(s)})}var q=0;function sch(){if(!q)q=setTimeout(function(){q=0;go()},150)}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',go):go();new MutationObserver(function(ms){for(var i=0;i<ms.length;i++){var a=ms[i].addedNodes;for(var j=0;j<a.length;j++){var n=a[j];if(n.nodeType===1&&n.className!=='smsm-rate'&&n.matches&&(n.matches('.product-item,.grid__item,.swiper-slide')||n.querySelector('.product-item'))){sch();if(window.smsmCdStart)window.smsmCdStart();return}}}}).observe(document.documentElement,{subtree:true,childList:true})})();
;
(function(){function go(){var src=document.querySelector('.sale_badge .product__badges-custom');var m=document.querySelector('.product-detail__media .media-main-swiper');if(!src||!m||m.querySelector('.smsm-cbadge'))return;if(getComputedStyle(m).position==='static')m.style.position='relative';var b=document.createElement('span');b.className='smsm-cbadge';b.textContent=src.getAttribute('data-label')||src.textContent.trim();if(src.getAttribute('data-ends'))b.setAttribute('data-ends',src.getAttribute('data-ends'));b.style[getComputedStyle(m).direction==='rtl'?'left':'right']='16px';m.appendChild(b)}document.readyState==='loading'?document.addEventListener('DOMContentLoaded',go):go();setTimeout(go,1500)})();
;
(function(){var EN=(document.documentElement.lang||'').indexOf('en')===0,P=EN?'ends in':'ينتهي خلال';function pad(n){return n<10?'0'+n:''+n}function fmt(s){return Math.floor(s/3600)+':'+pad(Math.floor(s%3600/60))+':'+pad(s%60)}function mk(c,t){var e=document.createElement(c==='smsm-cd-t'?'b':'span');e.className=c;if(t)e.textContent=t;return e}function prep(el){if(el.getAttribute('data-cd'))return;var l=el.getAttribute('data-label')||el.textContent.trim();el.setAttribute('data-label',l);el.setAttribute('data-cd','1');el.textContent='';el.appendChild(mk('smsm-cd-l',l));el.appendChild(mk('smsm-cd-sep','·'));el.appendChild(mk('smsm-cd-p',P));var t=mk('smsm-cd-t');t.dir='ltr';el.appendChild(t)}function tick(){var now=Date.now()/1000;document.querySelectorAll('.product__badges-custom[data-ends],.smsm-cbadge[data-ends]').forEach(function(el){var e=parseInt(el.getAttribute('data-ends'),10);if(!e)return;var left=Math.floor(e-now);if(left<=0){el.style.display='none';return}prep(el);var t=el.querySelector('.smsm-cd-t'),v=fmt(left);if(t&&t.textContent!==v)t.textContent=v})}var iv=null;function start(){if(iv||document.hidden)return;if(!document.querySelector('.product__badges-custom[data-ends],.smsm-cbadge[data-ends]'))return;tick();iv=setInterval(tick,1000)}function stop(){if(iv){clearInterval(iv);iv=null}}window.smsmCdStart=start;document.addEventListener('visibilitychange',function(){document.hidden?stop():start()});start();document.addEventListener('DOMContentLoaded',start);window.addEventListener('load',start)})();
